import React from 'react';
import helpmybussiness from '../components/helpmybussiness.jpg';
import saved_business from './data.js';
import Button from 'react-bootstrap/Button';

class Main extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            allCountries: [],
            getFilteredBusinessData:[],
            sourceData:[],
            isLoaded:false,
            randomSearchLableName:""
        }
    }
    

    async componentDidMount(){
        /** Thanks to https://www.geojs.io/docs/v1/endpoints/geo/ for letting fetch the user country based on geo */
        await fetch('https://get.geojs.io/v1/ip/geo.json')
        // await fetch('https://restcountries.eu/rest/v2/all')
        .then(response => {
            return response.json()
        })
        .then(allCountries => {
            this.setState({
                isLoaded:true,
                allCountries:allCountries,
                getFilteredBusinessData:saved_business.filter(business => business.state.toLowerCase() === allCountries.region.toLowerCase()),
                sourceData:saved_business.filter(business => business.state.toLowerCase() === allCountries.region.toLowerCase()),
            })
        })
        .catch(function(error) {
          this.setState({
            isLoaded:false
          })
          console.log('Request failed', error)  
        });  
    }

    handleChange = (event) => {
        let search = event.target.value;
        let {sourceData} = this.state;
        const updatedList = sourceData.filter(currentBusiness => 
            currentBusiness.businessName.toLowerCase().indexOf(search.toLowerCase()) > -1
        )
        this.setState({
            getFilteredBusinessData:updatedList,
            randomSearchLableName: search
        })
    }

     selectRandomBusiness = () => {
        let {sourceData} = this.state;
        if(sourceData.length >=1){
            // getFilteredItem should be array
            let randomItem = [sourceData[Math.floor(Math.random() * sourceData.length)]];
            let randomSearchLableName = randomItem[0].businessName;
            this.setState({
                getFilteredBusinessData: randomItem,
                randomSearchLableName
            })
        }
        else {
            alert('We regret to inform you that currently no business has been registred with SaveYourFave in your region')
        }
    }

    render(){
        /** If not able to locate the IP Address do not render the page */
        if(!this.state.isLoaded){return null}
        const {getFilteredBusinessData,randomSearchLableName} = this.state;
        let user_country = this.state.allCountries.region || "California";
        let displayBusiness = getFilteredBusinessData.map(business => {
            return (
                <div>
                    <h4>{business.businessName}</h4>
                    <p>{business.businessAddress}</p>
                    <p>{business.businessDescription}</p>
                    <div className="payment-details">
                    <p className="payment-method"><b>Payment Method: {business.paymentMethod}</b></p>
                    <Button target="_blank" href="https://www.paypal.com/signin?returnUri=https%3A%2F%2Fwww.paypal.com%2Fpaypalme&state=%2Fmy%2Flanding%3Fentry%3Dmarketing" variant="info donate-now-button">DONATE NOW</Button>
                    </div>
                    <hr className="grid-line"/>
                </div>
            )
        })
        return(
        <>  
            <div className="header">
                <div className="header-content apply-for-smallerviewport">
                    SaveYourFave
                </div>
                <div className="register-button-container">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdwIpkhH_smPY4VJN20dWdwv0ugRlrVd9M7S_XJo__PavAHmQ/viewform" target="_blank" className="register-button">Register a business</a>
                </div>
            </div>
            <div className="main">
                <div className="save-your-business">
                    <h5 className="save-your-business-content">Help save your favourite business in {user_country} &#10084;</h5>
                </div>
            <div className={'register-container'}>
              <div className="save-your-bussiness">
                <h5> <b>Help Your Community Service Workers During The Coronavirus Crisis</b> </h5> 
                <hr/>
              </div>
              <div className="content">
                 Coronavirus is having a devastating impact on upstart small businesses around the globle and it has brought the whole world to a halt. Restaurants have closed or are offering only takeout and delivery options, hotel business has slowed dramatically, most of daycares across the country remains close. As a result most of the employees already losing their jobs.<br/><br/>
                  While <b>SaveYourFave</b> helps you to find  local businesses in your region facing financial loss due to (COVID-19) pandemic so we as the community can help save the staff.
              <hr className="grid-line"/>
              </div>
              <div className="register-bussiness">
               <h4>Register your Business</h4>
                 <p className="help-bussiness-register">Tell/Help your favourite business to register with <b>SaveYourFave </b> by <b><a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdwIpkhH_smPY4VJN20dWdwv0ugRlrVd9M7S_XJo__PavAHmQ/viewform">filling out this form</a></b> so we all as community can help save their employees.
                    Taking care of each other is how we will get through this as a community.
                  </p> 
                 <hr className="grid-line"/>
              </div>
              <div className="select-random-business">
                  <div className="select-random-container">
                  <p className="select-random-business-content"><b>Are you new in town and want to help out?</b></p>
                  <Button variant="info select-random-button" onClick={this.selectRandomBusiness}>Select Random Business</Button>
                  </div>
                <hr className="grid-line" style={{width:'400px'}}/>
              </div>
              <div className="bussiness-names">
               <div class="search-box">
                   <p className="help-bussiness-register search-text"><b>Search your favourite business in {user_country}</b>&#10084;</p>
                   <input className="form-control input-search" value={randomSearchLableName} onChange={this.handleChange} type="text" placeholder= 'Search Business'></input>
               </div>
                <div className="display-business">
                    {saved_business.length <= 0 ? <p>We regret to inform you that currently no business has been registred with <b>SaveYourFave</b> in your region</p> : ''}
                   <hr className="grid-line"/>
                    {displayBusiness}
                </div>
              </div>
            </div>
            </div>
            <div className="about-us-container">
                <div className="about-us-content">
                    <div>
                    <h5 className="about-save-your-fav">About SaveYourFave</h5>
                    </div>
                    <div class="about-content">
                        <p>Founded in 2020.This is a volunteer effort and we are here to support the small business around the globe to address the business challenges due to the coronavirus disease(COVID-19) pandemic.</p>                
                    </div>
                    {/* Display only viewports that are 786 and more */}
                    <div className="copy-right">
                       Developed and Manage by Muneeb Muhammed Copyright © 2020 | All rights reserved.
                    </div>
                </div>
                {/* Image Container */}
                <div className="image-container">
                   <img className="help-save-business-image" src={helpmybussiness}/>
                   {/* Display only viewports that are 786 and more */}
                    <div className="social-media-icon"> 
                   <p className="follow-us">Follow us</p>
                   <div className="icons">
                        <a target="_blank" href="https://www.facebook.com/Saveyourfave-111333250512899" class="fa fa-facebook"></a>
                        <a target="_blank" href="https://www.instagram.com/saveyourfave/" class="fa fa-instagram"></a>
                        <a href="https://twitter.com/FavesSave" target="_blank" class="fa fa-twitter"></a>
                   </div>
                </div>
               </div>     
            </div>
            {/* DISPLAY ICONS FOR VIEWPORT THAT ARE 767 AND LESS */}
            <div className="footer">
                <div className="copy-right-manage">
                    Developed and Manage by Muneeb Muhammed Copyright © 2020 | All rights reserved.
                    <hr className="footer-grid-line"/>
                </div>
                <div className="icon-container"> 
                   <div className="icons">
                        <a target="_blank" href="https://www.facebook.com/Saveyourfave-111333250512899" class="fa fa-facebook"></a>
                        <a target="_blank" href="https://www.instagram.com/saveyourfave/" class="fa fa-instagram"></a>
                        <a href="https://twitter.com/FavesSave" target="_blank" class="fa fa-twitter"></a>
                   </div>
                </div>
            </div>
        </>
        )
    }
}

export default Main;